import fetch from 'isomorphic-fetch';
import qs from 'query-string';

import { checkStatus, parseJSON, dispatchError } from '../utils/fetch';
import {
  RESERVE_REQUEST,
  RESERVE_FAILURE,
  RESERVE_SUCCESS,
  RESERVE_TIMEOUT
} from '../constants/ActionTypes';
import packageKey from '../utils/packageKey';
import addOnKey from '../utils/addOnKey';
import { first } from '../utils';
import { parseISOLocal } from '../utils/date';
import { format } from 'date-fns';

function reserveRequest(sale, pkg) {
  return {
    type: RESERVE_REQUEST,
    sale,
    pkg
  };
}

function reserveFailure(sale, pkg, error, errors) {
  return {
    type: RESERVE_FAILURE,
    sale,
    pkg,
    error,
    errors
  };
}

function reserveSuccess(sale, pkg, itmres_no, hold) {
  return {
    type: RESERVE_SUCCESS,
    sale,
    pkg,
    itmres_no,
    date: new Date(),
    reservationHoldMinutes: hold,
    timeout: setTimeout(reserveTimeout, 5000)
  };
}

function reserveTimeout() {
  return {
    type: RESERVE_TIMEOUT
  };
}

export default function reserve(saleId) {
  return (dispatch, getState) => {
    const config = getState().config;

    const {
      sale: { sale },
      inventory
    } = getState();

    const date = parseISOLocal(sale.day);
    const dateString = format(date, 'yyyyMMdd');

    const inventoryPackages = inventory.packages[packageKey(sale.day)] || [];
    const newReservations = Object.keys(sale.packages)
      .filter(pkgId => !(pkgId in sale.reservedPackages))
      .filter(pkgId => {
        const pkg = first(inventoryPackages, pkg => pkg.item_id == pkgId);
        if (pkg == null) return false;
        if (pkg.limit != null && pkg.limit != '') return true;

        return false;
      })
      .map(pkgId => {
        const pkg = first(inventoryPackages, pkg => pkg.item_id == pkgId);
        if (pkg == null) return;

        return {
          department: pkg.department,
          category: pkg.category,
          item: pkg.item,
          quantity: sale.packages[pkgId].qty,
          startDate: dateString,
          startTime: `${sale.packages[pkgId].time || '0000'}00`,
          holdTime: config.reservationHoldMinutes,
          pkg
        };
      });

    Object.keys(sale.packageAddOns).forEach(pkgId => {
      Object.keys(sale.packageAddOns[pkgId])
        .filter(addOnId => !(addOnId in sale.reservedPackages))
        .filter(addOnId => {
          const pkg = first(inventoryPackages, pkg => pkg.item_id == pkgId);
          if (pkg == null) return false;

          const addOns = inventory.addOns[addOnKey(sale.day, pkg)];
          const addOn = first(addOns, addOn => addOn.item_id == addOnId);

          if (addOn.limit != null && addOn.limit != '') return true;

          return false;
        })
        .forEach(addOnId => {
          const pkg = first(inventoryPackages, pkg => pkg.item_id == pkgId);
          if (pkg == null) return;

          const addOns = inventory.addOns[addOnKey(sale.day, pkg)];
          const addOn = first(addOns, addOn => addOn.item_id == addOnId);

          const addOnQtyTime = sale.packageAddOns[pkgId][addOnId];
          const addOnQty = addOnQtyTime.qty || 0;
          const addOnTime = addOnQtyTime.time || '000000';

          const addOnRes = {
            department: addOn.department,
            category: addOn.category,
            item: addOn.item,
            quantity: addOnQty,
            startDate: dateString,
            startTime: addOnTime === '000000' ? '000000' : `${addOnTime}00`,
            holdTime: config.reservationHoldMinutes,
            pkg: addOn
          };

          newReservations.push(addOnRes);
        });
    });

    if (newReservations == null || newReservations.length < 1) {
      return new Promise(resolve => resolve());
    }

    newReservations.map(res => {
      var dto = { ...res };
      delete dto['pkg'];

      return new Promise((resolve, reject) => {
        dispatch(reserveRequest(sale, res.pkg));

        fetch(
          `${config.apiUrl}/sales/${
            sale.id == null ? saleId : sale.id
          }/reservation?${qs.stringify({
            client: config.client
          })}`,
          {
            method: 'post',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(dto)
          }
        )
          .then(checkStatus)
          .then(parseJSON)
          .then(itmres_no => {
            dispatch(
              reserveSuccess(
                sale,
                res.pkg,
                itmres_no,
                config.reservationHoldMinutes
              )
            );
            resolve();
          })
          .catch((...args) => {
            dispatchError(dispatch, reserveFailure.bind(this, sale, res.pkg))(
              ...args
            );
            reject();
          });
      });
    });

    // optimistic
    return new Promise(resolve => resolve());
  };
}
